import React, { useState } from "react";
import { toggle_off, toggle_on, tootltip } from "../../assets/img";

const BookingDetails = ({ data }) => {
  const [toolTip, setToolTip] = useState(false);
  let value = data?.status;
  const toolTipmessages = {
    No_Of_Persons: "No of rooms + Person",
    Guest_Count: " No of rooms  (min Adult+min child)",
    Extra_Person: "No of rooms  (max Adult+ max child)",
  };
  const showToolTip = (d) => {
    setToolTip(d);
    setTimeout(() => {
      setToolTip(false);
    }, 1500);
  };
  return (
    <div className="roles-bg rounded-4 col-md-5 mt-0">
      <div className="d-flex ac-js gap-2 mt-2">
        <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
          Booking Details
        </h2>
        <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 bg-sec1  p-2 rounded-2">
          {data?.special_price ? "Special Day" : "Normal Day"}
        </p>
        <img
          src={data?.special_price ? toggle_on : toggle_off}
          className="roles-icon"
          alt=""
        />
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          Booking ID
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.booking_id}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          Booked Date
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.booked_date}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          No Of Rooms
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.no_of_rooms}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Slot
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.slot}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Guest Name{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.guest_name}
        </p>
      </div>
      <div className="d-flex as-js mt-3 position-relative">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          No Of Min Person{" "}
          <img
            src={tootltip}
            onClick={() => {
              showToolTip("No_Of_Persons");
            }}
            className="tooltip-icon"
            alt=""
          />
          {toolTip === "No_Of_Persons" && (
            <div className="tooltip-popup absolute">
              <p className="tooltip-text">{toolTipmessages[toolTip]}</p>
            </div>
          )}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.no_of_persons}
        </p>
      </div>
      <div className="d-flex as-js mt-3 position-relative">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Guest Count{" "}
          <img
            src={tootltip}
            onClick={() => {
              showToolTip("Guest_Count");
            }}
            className="tooltip-icon"
            alt=""
          />
          {toolTip === "Guest_Count" && (
            <div className="tooltip-popup absolute">
              <p className="tooltip-text">{toolTipmessages[toolTip]}</p>
            </div>
          )}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.guest_count}
        </p>
      </div>
      <div className="d-flex as-js mt-3 position-relative">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Extra Person{" "}
          <img
            src={tootltip}
            onClick={() => {
              showToolTip("Extra_Person");
            }}
            className="tooltip-icon"
            alt=""
          />
          {toolTip === "Extra_Person" && (
            <div className="tooltip-popup absolute">
              <p className="tooltip-text">{toolTipmessages[toolTip]}</p>
            </div>
          )}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.extra_persons}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          From Date{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.from_date}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          To Date{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.to_date}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Check In Date{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.check_in_date}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Check Out Date{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.check_out_date}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Current Status{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.current_status}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Status{" "}
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          :{" "}
          {(value === "Check Out" || value === "Auto Checkout") &&
          value === "Release"
            ? "Completed"
            : value === "Check In" ||
              value === "Release" ||
              value === "User Booked"
            ? "Booked"
            : value === "Owner Cancelled"
            ? "requested for absent"
            : value}
        </p>
      </div>
    </div>
  );
};

export default BookingDetails;
